<template>

	<ArticleSection>
		<div :class="{'articleTop-dark': isDark, 'articleTop-half': isHalf, 'articleTop-imageBottom': hasImageBottom}"
		     class="articleTop">
			<div ref="articleTop_image"
			     :class="{'contain': isContain}"
			     :style="{'background-image': 'url(' + imgPath(image) + ')', 'background-position': imageOffset, 'background-color': bgColor}"
			     class="articleTop_image"
			>
				<ImageZoomable
						v-if="showImageZoomable"
						ref="imageZoomable"
						:bgPos="imageOffset"
						:containZoom="containZoom"
						:noZoom="noZoom"
						:src="image"
						noAppearEffect
						@unzoomed="onUnZoomHandler"
						@zoomed="onZoomHandler"
				/>
				<div v-if="imageCaption" class="articleTop_caption" v-html="imageCaption">
				</div>
			</div>
			<div ref="articleTop_content"
			     :style="{'background-color': contentBg, 'color': contentColor}"
			     class="articleTop_content"
			>
				<h2>{{subTitle}}</h2>
				<h1 :class="{'reduceSize': isReduce}" v-html="title"></h1>
				<div v-if="intro" ref="articleTop_content_intro" class="articleTop_content_intro" v-html="intro">
				</div>
				<Author v-if="!authorEnd"
				        ref="author"
				        :image="authorImage"
				        :name="authorName"
				        :quote="authorQuote"
				        :title="authorTitle"
				></Author>
				<div v-if="experts" class="articleTop_content_expert">
					<AuthorList ref="expert" :expertTitle="expertTitle" :experts="experts"></AuthorList>
				</div>
				<slot></slot>

				<Author v-if="authorEnd"
				        ref="author"
				        :image="authorImage"
				        :name="authorName"
				        :quote="authorQuote"
				        :title="authorTitle"
				></Author>
			</div>
		</div>

		<Scrolldown @click.native="scrollDown()"></Scrolldown>
	</ArticleSection>

</template>

<script>
import ArticleSection from "./ArticleSection";
import Author from "./Author";
import AuthorList from "./AuthorList";
import {TimelineMax, Expo} from "gsap/TweenMax";
import Scrolldown from "./Scrolldown";
import ButtonSound from "./ButtonSound";
import {Device, EBreakPoint} from "../utils/Device";
import ImageZoomable from "./ImageZoomable";

export default {
	name: "ArticleTop",
	components: {ImageZoomable, ButtonSound, Scrolldown, Author, ArticleSection, AuthorList},
	props: ["sound", "image", "imageOffset", "imageBottom", "bgColor", "authorOffset", "title", "subTitle", "intro", "authorName", "authorImage", "authorQuote", "authorTitle", "authorEnd", "animationType", "imageCaption", "experts", "isReduce", "expertTitle", "noZoom", "containZoom", "contentBg", "contentColor"],
	data: function () {
		return {
			isDark: false,
			showImageZoomable: false,
			isHalf: false,
			isContain: false,
			hasImageBottom: false
		};
	},
	mounted: function () {
		//this.$events.listen('page-scrolling', this.reduce);
		this.$events.fire("page-lockScroll");
		// on réduit la page que si on est en mode suppérieur a SM
		// if(Device.isUpTo(EBreakPoint.SM)){
		this.reduce();
		// }
		if (this.isContain == "true") {
			this.isContain = true;
		}
		console.log("imageBottom");
		console.log(this.imageBottom);
		if (this.imageBottom == "true") {
			this.hasImageBottom = true;
		}
		//console.log('mounted');
	},

	methods: {
		onZoomHandler: function () {
			TweenMax.to(this.$refs.articleTop_content, 0.5, {alpha: 0});
		},
		onUnZoomHandler: function () {
			TweenMax.to(this.$refs.articleTop_content, 0.5, {alpha: 1});
		},
		imgPath: function (img) {
			return require("../assets/img/" + img);
		},
		reduce: function () {
			// pas besoin de relancer la tween si on est déja en mode dark
			if (this.isDark) return;
			this.isDark = true;
			// let t = new TimelineMax();
			//
			//
			// if (this.animationType == "half_anim") {
			//     this. isHalf = true;
			//     let left_img = 0;
			//     t.to(this.$refs.articleTop_image, 1.5, {width: '50%', left: left_img, ease: Expo.easeInOut});
			//     t.add(() => {this.showImageZoomable = true;})
			// }
			// else {
			//     let left_img = Device.vp.w*0.3;
			//     t.to(this.$refs.articleTop_image, 1.5, {width: '20%', left: left_img, ease: Expo.easeInOut});
			//     t.add(() => {this.showImageZoomable = true;})
			// }

			let author = this.$refs.author.$el;
			TweenMax.to(author, 1, {
				delay: 0.5,
				opacity: 1,
				ease: Expo.easeInOut
			});

			if ("expert" in this.$refs) {
				let expert = this.$refs.expert.$el;
				TweenMax.to(expert, 1, {
					delay: 0.5,
					opacity: 1,
					ease: Expo.easeInOut
				});
			}

			this.$events.fire("menu-fadeout");

		},
		scrollDown: function () {
			this.$events.fire("page-scrollSection", {nb: 1});
			this.$events.fire("page-unlockScroll");
			if ("imageZoomable" in this.$refs) {
				this.$refs.imageZoomable.unzoom();
			}
			// save path url in localstorage array
			let path = this.$route.params.page;
			let paths = JSON.parse(localStorage.getItem("pagesSeen")) || [];
			if (paths.indexOf(path) === -1) {
				paths.push(path);
				localStorage.setItem("pagesSeen", JSON.stringify(paths));
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.articleTop {
	min-height: dvh(100);
	position: relative;
	color: #ffffff;

	& > * {
		transition: color 1.5s linear;
	}

	&-dark {
		color: #000000;
		transition-delay: 2s;

		& > * {
			color: #000000;
		}
	}

	&_image {
		position: absolute;
		z-index: 1;
		left: 0;
		width: 50%;
		top: 0;
		height: 100vh;
		background-size: cover;
		background-position: center center;
		background-repeat: no-repeat;

		@include breakpoint(xs) {
			height: dvh(50);
			width: 100%;
			position: static;
		}

		&.contain {
			background-size: contain;
		}
	}

	&_caption {
		font-size: 1.5rem;
		position: absolute;
		bottom: 3rem;
		right: 3rem;
		padding: $G-default;
		width: 30rem;
		text-align: right;
		background-color: white;
		@include breakpoint(lt-sm) {
			opacity: 0;
			transition: 0.25s;
			bottom: calc(50% + 3rem);
			right: $G-default;
			background-color: white;
			left: auto;
		}
	}

	.articleTop_image:hover {
		.articleTop_caption {
			@include breakpoint(lt-sm) {
				opacity: 1;
				transition: 0.25s;
			}
		}
	}

	&_content {
		width: calc(50% - 3rem);
		margin-left: calc(50% + 3rem);
		padding-left: $G-default;
		padding-right: $G-default*4;
		overflow: hidden;
		position: relative;
		z-index: 2;

		@include breakpoint(xs) {
			width: 100%;
			margin: 0;
			color: black;
			transform: none;
			padding: 2.5rem $G-default;
		}

		@include breakpoint(sm) {
			background-color: transparent !important;
		}

		h1 {
			font-size: 5.5rem;
			font-weight: $FW-bold;
			text-transform: initial;
			margin-top: $G-default;
			margin-bottom: $G-default * 2;
			//letter-spacing: 0.05em;

			@include breakpoint(xs) {
				text-align: center;
				margin: 0 auto $G-default;
				font-size: 3rem;
				width: calc(70vw - 5rem);
			}

			&.reduceSize {
				font-size: 4.5rem;
			}
		}

		h2 {
			font-size: 3.2rem;
			font-weight: $FW-medium;
			text-transform: initial;
			margin-top: $G-default * 3;
			//letter-spacing: 0.05em;

			@include breakpoint(xs) {
				text-align: center;
				font-size: 2.5rem;
				margin-top: 0;
			}
		}


		&_intro {
			margin-top: $G-default / 2;
		}
	}

	.author {
		margin-top: $G-default;
		opacity: 0;
	}

	.author_list {
		opacity: 0;
		@include breakpoint(xs) {
			opacity: 1;
		}
	}

	&-half {
		.articleTop_caption {
			z-index: $ZI-scrolldown;
			width: fit-content;
			max-width: 25%;
			text-align: left;
			padding: $G-default / 2;
			font-size: 1.5rem;
			color: #000000;
			background: #ffffff;
			box-sizing: border-box;
			left: $G-default;
			bottom: $G-default;
		}
	}

	&-imageBottom {
		.articleTop_image {
			@include breakpoint(ht-xs) {
				background-position: center bottom !important;
			}
		}
	}

}
</style>
